export default {
  module: 'MESSAGECENTER',
  QUERY_MESSAGE_CENTER_APP_LIST: {
    url: '/xdap-admin/msg/query/mpMessage',
    method: 'post',
    disableSuccessMsg: true
  },
  QUERY_MESSAGE_BY_APP: {
    url: '/xdap-admin/msg/query/appMpMessage',
    method: 'post',
    disableSuccessMsg: true
  },
  READ_MESSAGE_BY_APP: {
    url: '/xdap-admin/msg/read/appMessage',
    method: 'post',
    disableSuccessMsg: true
  }
}
